<template src="./html/Create.html"></template>

<script>
	import Multiselect from 'vue-multiselect'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				modal: {
					selector: 'project-create',
				},

				data: {
					name: null,
					description: null,
					customers: [],
					user_id: null,
					team_id: null,
					places: [],
					budget_id: null,
					order_id: null,
					invoice_id: null,
				},

				customers: [],
				statuses: null,
				users: null,
				teams: null,

				customersSelected: [],

				multiselect: {
					loading: false,
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getStatuses()
				this.getTeams()
				this.getUsers()
			},
			open(order) {
				this.clearData()
				if(order) {
					this.data.budget_id = order.budget_id
					this.data.order_id = order.id
					this.data.invoice_id = order.invoice_id
					if(order.title) {
						this.data.name = order.title
					}
					if(order.description) {
						this.data.description = order.description
					}
					if(order.customer) {
						var customer = order.customer
						if(customer.places) {
							if(customer.places.length) {
								var place = customer.places[0]
								this.$set(customer, 'selected', [])
								customer.selected.push(place)
								this.data.places.push(place)
							}
						}

						this.data.customers.push(customer)
						this.customersSelected.push(customer)
					}
					if(order.author_id) {
						this.data.user_id = order.author_id
					}
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getTeams() {
				this.$http.get('admin/projects/teams')
					.then(response => {
						this.teams = response.body
					})
			},
			getUsers() {
				var data = {
					roles: [
						'admin', 'manager', 'external_manager'
					]
				}
				this.$http.post('admin/roles/users', data)
				.then(response => {
					this.users = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			clearData() {
				this.data.name = null;
				this.data.description = null;
				this.data.customers = [];
				this.data.user_id = null;
				this.data.team_id = null;
				this.data.places = [];
				this.customersSelected = [];
			},
			store() {
				var loading = Ladda.create(this.$refs.btnStore)
				loading.start()
				this.$http.post('admin/projects/projects', this.data)
				.then(response => {
					loading.stop()
					this.close()
					this.$emit('reload')
					this.continueOrCreateTask(response)
				}).catch(function(response) {
					console.log(response)
					loading.stop()
				})
			},
			getStatuses() {
				this.$http.get('admin/projects/projects/statuses')
					.then(response => {
						this.statuses = response.body
					})
			},
			getCustomers(text) {
				this.multiselect.loading = true
				this.customers = []
				this.$http.get('admin/customers?per_page=50&sort=id|desc&text=' + text)
				.then(response => {
					this.customers = response.body.data
					this.multiselect.loading = false
				}).catch(response => {
					console.log(response)
					this.multiselect.loading = false
				})
			},
			customerSelected(customer) {
				if(customer.places) {
					if(customer.places.length) {
						this.customersSelected.push(customer)
					}
				}
			},
			customerRemoved(customer) {
				if(customer.places) {
					if(customer.places.length) {
						var that = this
						customer.selected = []
						var index = this.customersSelected.indexOf(customer)
						this.customersSelected.splice(index, 1)

						customer.places.forEach(function(place) {
							var index = that.data.places.indexOf(place)
							that.data.places.splice(index, 1)
						})
					}
				}
			},
			placeSelected(place) {
				this.data.places.push(place)
			},
			placeRemoved(place) {
				var index = this.data.places.indexOf(place)
				this.data.places.splice(index, 1)
			},
			continueOrCreateTask(data) {
				var that = this
				swal({
					title: data.body.title,
					text: data.body.text,
					type: data.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Crear tarea',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$emit('createTask', data.body.data)
				}).catch(function() {
					that.close()
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Create.vue